<script setup lang="ts">

import { FeatureFrame } from "../Components";
import type { ITheftRecoveryFeature } from "@domain/CarePlan";

const model = defineModel<ITheftRecoveryFeature>( { required: true } ); 

</script>

<template>

    <FeatureFrame>
        
        <template #title>{{ model.title }}</template>
        <template #sub-title>Enables your car to be found if it gets stolen</template>

        <div class="flex flex-col w-full">

            <!-- PROPERTIES -->
            <div class="flex flex-col w-full gap-1 pt-4
                        text-xs lg:text-sm 3xl:text-base tracking-wider">
               
                <div class="flex flex-col gap-0.5 3xl:text-lg">
                    <div class="text-xs 3xl:!text-base 3xl:py-2 text-gray-400 uppercase mb-2 text-center">
                        Your car is protected by a theft recovery device
                    </div>

                    <!-- VEHICLE HEALTH CHECKS -->
                    <div class="flex gap-2 3xl:py-1">
                        <div>Installed</div>
                        <div class="flex-1 border-b-2 border-dotted opacity-60" />
                        <Icon name="check" class="-mb-1.5 text-2xl 3xl:text-3xl" />
                    </div>  

                </div>
                
            </div>

            <!-- ACTIONS -->
            <div class="w-full flex flex-col pt-4
                        gap-x-1 gap-y-3 md:gap-x-2 md:gap-y-4 3xl:gap-4 mt-4 3xl:mt-6">

                <div class="-mb-2 -mt-2 flex justify-stretch w-full">
                    <Button variant="text"
                            to="/my-garage/theft-recovery"
                            class="!h-10 lg:!h-12 3xl:!h-14 grow">
                        More Details
                    </Button>
                </div>
                
            </div>

        </div>

    </FeatureFrame>
        
</template>
